import { render, staticRenderFns } from "./OrgForm.vue?vue&type=template&id=d79c6f20"
import script from "./OrgForm.vue?vue&type=script&lang=ts"
export * from "./OrgForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports